import { AlphaOCircleOutlineIcon } from './AlphaOCircleOutlineIcon';

/**
 * author: Contributors
 * id 485D936E-F9F7-4D89-A2CC-2C11268EAC1A
 * name alpha-o-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-o-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterOCircleOutlineIcon = AlphaOCircleOutlineIcon;
export default LetterOCircleOutlineIcon